class BlogPredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input#blogSearch');
    this.form = this.querySelector('form')
    this.predictiveSearchResults = this.querySelector('#blog-predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.addEventListener('focusout', this.debounce((event) => {
      this.close()
    }, 200).bind(this))

    this.form.addEventListener('submit', function(event) {
      event.preventDefault();
      const searchTerm = this.input.value.trim();
      window.location.href = `https://www.aquariumcoop.com/apps/omega-search/?index=posts&limit=16&q=${searchTerm}&view=grid`
    }.bind(this))
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=query,article&section_id=blog-predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-blog-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('blog-predictive-search', BlogPredictiveSearch);
